/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

import { dashboard as dashboardCore } from '@breezeway/brzw-react-core';
import * as actions from './actions';

const propertyLoadingParams = options => {
  const filterWithoutReservationAndTaskDepartment = _.omit(options, ['reservation']);

  return _.omitBy(
    {
      ...filterWithoutReservationAndTaskDepartment,
      reservation_event: _.get(options, 'reservation_event'),
    },
    filter => !(_.isNumber(filter) || !_.isEmpty(filter)),
  );
};

/**
 * @param {Function} action
 * @param {String} date
 * @param {Object} options
 */
export const loadPropertyPart = (action, date, options) => dispatch => {
  if (date) {
    dispatch(action(date, options, null, dispatch.bind(this, actions.setPropertiesError())));
  } else {
    dispatch(action(options, null, dispatch.bind(this, actions.setPropertiesError())));
  }
};

/**
 * @param {String} date
 * @param {Array} propertyIds
 * @param {Object} filters
 */
export const loadPropertyTasks = (date, propertyIds, filters = {}) => dispatch => {
  const tasksOptions = {
    company_people_id: _.get(filters, 'company_people_id', []),
    home_id: propertyIds,
    task_department: [],
    task_priority: [],
    task_status: _.get(filters, 'task_status', []),
  };

  dispatch(loadPropertyPart(dashboardCore.actionsV2.loadDashboardTasks, date, tasksOptions));
};

/**
 * @param {String} date
 * @param {Array} propertyIds
 */
export const loadPropertyIssues = (date, propertyIds) => dispatch => {
  const options = { home_id: propertyIds };

  dispatch(loadPropertyPart(dashboardCore.actionsV2.loadDashboardIssues, date, options));
};

/**
 * @param {String} date
 * @param {Array} propertyIds
 * @param {Object} filters
 */
export const loadPropertyParts = (date, propertyIds, filters = {}) => dispatch => {
  const options = { home_id: propertyIds };

  dispatch(loadPropertyTasks(date, propertyIds, filters));
  dispatch(loadPropertyPart(dashboardCore.actionsV2.loadDashboardIssues, date, options));
  dispatch(loadPropertyPart(dashboardCore.actionsV2.loadDashboardRecentTasks, null, options));
  dispatch(loadPropertyPart(dashboardCore.actionsV2.loadDashboardLastComment, date, options));
  dispatch(loadPropertyPart(dashboardCore.actionsV2.loadDashboardGapNights, date, options));
};

/**
 * @param {String} date
 * @param {Object} options
 * @param {Boolean} shouldLoadListOnly
 */
export const loadProperties = (date, options = {}, shouldLoadListOnly = false) => dispatch => {
  const omittedFiltersForCharts = _.omit(options, ['reservation', 'limit', 'page']);
  const omittedFilters = propertyLoadingParams(options);

  dispatch(actions.startLoadingProperties());
  if (!shouldLoadListOnly) {
    dispatch(dashboardCore.actionsV2.loadDashboardStatuses(date, omittedFiltersForCharts));
    dispatch(dashboardCore.actionsV2.loadDashboardStatus(date, omittedFiltersForCharts));
  }
  dispatch(
    dashboardCore.actionsV2.loadDashboardProperties(
      date,
      omittedFilters,
      response => {
        const properties = _.get(response, 'results', []);
        if (!_.isEmpty(properties)) {
          const propertyIds = _.map(properties, 'id');
          dispatch(loadPropertyParts(date, propertyIds, omittedFilters));
        }
        dispatch(actions.stopLoadingProperties());
      },
      () => {
        dispatch(actions.stopLoadingProperties());
        dispatch(actions.setPropertiesError());
      },
    ),
  );
};

/**
 * @param {String} date
 * @param {Object} options
 */
export const loadMoreProperties = (date, options = {}) => dispatch => {
  const omittedFilters = propertyLoadingParams(options);

  dispatch(actions.startLoadingMoreProperties());
  dispatch(
    dashboardCore.actionsV2.loadMoreDashboardProperties(
      date,
      omittedFilters,
      response => {
        const properties = _.get(response, 'results', []);
        if (!_.isEmpty(properties)) {
          const propertyIds = _.map(properties, 'id');
          dispatch(loadPropertyParts(date, propertyIds, omittedFilters));
        }
        dispatch(actions.stopLoadingMoreProperties());
      },
      () => dispatch(actions.setPropertiesError()),
    ),
  );
};

// Map dashboard

/**
 * @param {String} date
 * @param {Object} options
 * @param {Boolean} isRefetching
 */
export const loadMapPeople = (date, options = {}, isRefetching = false) => dispatch => {
  const params = {
    limit: 'all',
    ...options,
  };

  if (!isRefetching) dispatch(actions.startLoadingMapPeople());
  dispatch(
    dashboardCore.actionsV2.getMapPeople(params, people => {
      const results = _.get(people, 'results', []);
      const peopleWithLocation = _.filter(results, 'location');
      const mapPeopleIds = _.map(peopleWithLocation, 'id');

      if (!_.isEmpty(mapPeopleIds)) {
        dispatch(
          dashboardCore.actionsV2.getMapPeopleTasks(date, mapPeopleIds, () => {
            if (!isRefetching) dispatch(actions.stopLoadingMapPeople());
          }),
        );
      } else if (!isRefetching) dispatch(actions.stopLoadingMapPeople());
    }),
  );
};

/**
 * @param {String} date
 * @param {Object} options
 * @param {Boolean} isRefetching
 */
export const loadMapProperties = (date, options = {}, isRefetching) => dispatch => {
  const params = {
    date_activity: 'all',
    limit: 'all',
    ...options,
  };

  if (!isRefetching) dispatch(actions.startLoadingMapProperties());
  dispatch(
    dashboardCore.actionsV2.getMapProperties(date, params, response => {
      const properties = _.get(response, 'results', []);

      if (!_.isEmpty(properties)) {
        dispatch(
          dashboardCore.actionsV2.getMapPropertiesTasks(
            {
              date_filter: 'scheduled',
              end_date: date,
              limit: 'all',
              start_date: date,
            },
            () => {
              if (!isRefetching) dispatch(actions.stopLoadingMapProperties());
            },
          ),
        );
      } else if (!isRefetching) dispatch(actions.stopLoadingMapProperties());
    }),
  );
};
